export default {
    sign_in: "Sign In"

}